import { render, staticRenderFns } from "./CartBar.vue?vue&type=template&id=34c3658e&scoped=true"
import script from "./CartBar.vue?vue&type=script&lang=js"
export * from "./CartBar.vue?vue&type=script&lang=js"
import style0 from "./CartBar.vue?vue&type=style&index=0&id=34c3658e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c3658e",
  null
  
)

export default component.exports